import type { LocaleCode, LocaleIsoCode } from "@/types";

export const DEFAULT_LOCALE = "en-us";
export const DEFAULT_ISO_LOCALE = "en-US";

export const LOCALES: LocaleCode[] = [
  "en-us",
  "es",
  "de",
  "fr",
  "pt",
  "ko",
  "zh",
  "ja",
];

export const ISO_LOCALES: LocaleIsoCode[] = [
  "en-US",
  "de-DE",
  "es-MX",
  "fr-FR",
  "ko-KR",
  "ja-JP",
  "pt-BR",
  "zh-CN",
];

export const LOCALE_TO_ISO: { [locale in LocaleCode]: LocaleIsoCode } = {
  "en-us": "en-US",
  es: "es-MX",
  de: "de-DE",
  fr: "fr-FR",
  pt: "pt-BR",
  ko: "ko-KR",
  zh: "zh-CN",
  ja: "ja-JP",
};

export const ISO_TO_LOCALE: { [locale in LocaleIsoCode]: LocaleCode } = {
  "en-US": "en-us",
  "es-MX": "es",
  "de-DE": "de",
  "fr-FR": "fr",
  "pt-BR": "pt",
  "ko-KR": "ko",
  "zh-CN": "zh",
  "ja-JP": "ja",
};
